// extracted by mini-css-extract-plugin
export default {"listar":"lista_listar__wYFKE","caixa":"lista_caixa__8X8P3"};